import {Component, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";
import {ModalComponent} from "@pb-labs/modal";
import {ButtonType} from "@pb-labs/button";
import {PublicKeyUploadModalService} from "./public-key-upload-modal.service";
import {fileUploadModalActions} from "@app/modules/browse/components/shared/file-upload-modal/const";
import {FileUploadModalLayoutService} from "@app/modules/browse/components/shared/file-upload-modal/layout/file-upload-modal-layout.service";

@Component({
  selector: "app-public-key-upload-modal",
  templateUrl: "./public-key-upload-modal.component.html",
  styleUrls: ["./public-key-upload-modal.component.scss"],
})
export class PublicKeyUploadModalComponent implements OnInit, OnDestroy {
  @ViewChild("modal") modal: ModalComponent;

  selectedFile: File = null;
  newPublicKey: string = null;
  readonly buttonType = ButtonType;
  private _destroy$: Subject<void> = new Subject<void>();

  constructor(
    private publicKeyUploadModalService: PublicKeyUploadModalService,
    private fileUploadModalLayoutService: FileUploadModalLayoutService
  ) {}

  get fileUploading(): boolean {
    return this.publicKeyUploadModalService.isFileUploading;
  }

  get fileValidationMessage(): string {
    return this.publicKeyUploadModalService.validationErrorMessage;
  }

  ngOnInit(): void {
    this.publicKeyUploadModalService.open$.pipe(takeUntil(this._destroy$)).subscribe(() => {
      this.fileUploadModalLayoutService.openModal();
    });

    this.publicKeyUploadModalService.close$.subscribe(() => {
      this.fileUploadModalLayoutService.closeModal();
    });

    this.publicKeyUploadModalService.selectedFile$.pipe(takeUntil(this._destroy$)).subscribe((selectedFile: File) => {
      this.selectedFile = selectedFile;
    });

    this.publicKeyUploadModalService.newPublicKey$.pipe(takeUntil(this._destroy$)).subscribe((content: string) => {
      this.newPublicKey = content;
    });
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  isUploadedFileInvalid(): boolean {
    return !!this.fileValidationMessage;
  }

  clearFile(): void {
    this.publicKeyUploadModalService.clearFile();
  }

  onFileSelect(file: File): void {
    if (file) {
      this.publicKeyUploadModalService.onFileSelect(file);
    } else {
      this.clearFile();
    }
  }

  onCloseIconClick() {
    this.publicKeyUploadModalService.verify(fileUploadModalActions.Cancel);
  }

  isCloseIconDisabled(): boolean {
    return this.fileUploading;
  }

  onButtonClick(action: fileUploadModalActions): void {
    this.publicKeyUploadModalService.verify(action);
  }

  isUploadButtonDisabled(): boolean {
    return !this.selectedFile || this.isUploadedFileInvalid();
  }

  isUploadButtonBusy(): boolean {
    return this.fileUploading;
  }

  isCancelButtonDisabled(): boolean {
    return this.fileUploading;
  }
}
